import { updateItemInCollection } from "directus/src/operations";

export async function updateJobTitle({ item, jobtitleId }) {
  try {
    const data = await updateItemInCollection("job_titles", jobtitleId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
